<div class="flex flex-row p-6">
  <span class="flex-1"></span>
  <button type="button" mat-flat-button color="warn" (click)="cancel()">Close</button>
</div>
<br/>

<div class="flex flex-col gap-3">
  <div class="flex flex-row">
    <div class="flex flex-col w-[20%]">
      <mat-card>
        <ul navAccordion class="matero-sidemenu flex-1" style="width:auto">
          <ng-container *ngFor="let question of questions; let index = index">
            <li navAccordionItem class="matero-sidemenu-item" *ngIf="index !== 5 || serviceCenterData.partialQuarter" [ngClass]="{'active': currentQuestion === index}">
              <a matRipple (click)="changeQuestion(index)" style="line-height: 1.5; padding: 8px 0;">
                <span>{{question}}</span>
              </a>
            </li>
          </ng-container>
        </ul>
      </mat-card>
    </div>

    <div class="flex flex-col w-[80%]">
      <mat-card style="border-radius: 0;" class="w-[100%]">

        <div *ngIf="currentQuestion == 0">
          <span *ngIf="data.showNewFields"><b>1. Number of clients, administration sessions, group administration sessions, and client opt-outs</b></span>
          <span *ngIf="!data.showNewFields"><b>1. Number of clients, administration sessions, and group administration sessions</b></span>
          <form [formGroup]="clientForm">
            <div class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="clientsServed" type="number">
              </mat-form-field>
              <span class="w-[80%]">Number of Clients Served</span>
            </div>
            <div class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="individualAdministrationSessions" type="number">
              </mat-form-field>
              <span class="w-[80%]">Number of Individual Administration Sessions</span>
            </div>
            <div class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="groupAdministrationSessions" type="number">
              </mat-form-field>
              <span class="w-[80%]">Number of Group Administration Sessions</span>
            </div>
            <div *ngIf="data.showNewFields" class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="clientsOptedOut" type="number">
              </mat-form-field>
              <span class="w-[80%]">Number of Clients who Selected the “Client Opt-Out  Option”</span>
            </div>
          </form>
        </div>

        <div *ngIf="currentQuestion == 1">
          <span><b>2. Number of individuals who were denied psilocybin services</b></span>
          <form [formGroup]="deniedForm">
            <div class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="deniedTotal" type="number">
              </mat-form-field>
              <span class="w-[80%]">Number of Individuals who were denied psilocybin services</span>
            </div>
            <!-- <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" style="margin-left: 3%">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="deniedLithium" type="number">
              </mat-form-field>
              <span class="w-[80%]">Number of Individuals who were denied psilocybin services due to use of Lithium.</span>
            </div>
            <div style="margin-left: 3%" class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="deniedHarm" type="number">
              </mat-form-field>
              <span class="w-[80%]">Number of Individuals who were denied psilocybin services due to thoughts of causing harm to self or others.</span>
            </div>
            <div style="margin-left: 3%" class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="deniedPsychosis" type="number">
              </mat-form-field>
              <span class="w-[80%]">Number of Individuals who were denied psilocybin services due to active psychosis.</span>
            </div> -->
            <div style="margin-left: 3%" class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="deniedInconsistent" type="number" style="margin-left: 3%">
              </mat-form-field>
              <span class="w-[80%]">Client requested products or services that are inconsistent with the service center business model</span>
            </div>
            <div style="margin-left: 3%" class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="deniedIneligible" type="number" style="margin-left: 3%">
              </mat-form-field>
              <span class="w-[80%]">Facilitator notified service center that client is ineligible for services</span>
            </div>
            <div style="margin-left: 3%" class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="deniedIntoxicated" type="number" style="margin-left: 3%">
              </mat-form-field>
              <span class="w-[80%]">Client arrived at the service center intoxicated</span>
            </div>
            <div style="margin-left: 3%" class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="deniedConcerningBehavior" type="number" style="margin-left: 3%">
              </mat-form-field>
              <span class="w-[80%]">Client exhibited concerning behaviors after arriving at the service center</span>
            </div>
            <div style="margin-left: 3%" class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="deniedOther" type="number" style="margin-left: 3%">
              </mat-form-field>
              <span class="w-[80%]">Number of individuals who were denied psilocybin services due to other reasons.</span>
            </div>
          </form>
        </div>

        <div *ngIf="currentQuestion == 2">
          <span><b>3. Number of adverse reactions</b></span>
          <form [formGroup]="reactionForm">
            <div class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="behavioralReactions" type="number">
              </mat-form-field>
              <span class="w-[80%]">Number of clients who experienced adverse behavioral reactions.</span>
            </div>
            <div class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="severeBehavioralReactions" type="number">
              </mat-form-field>
              <span class="w-[80%]">Number of clients who experienced severe adverse behavioral reactions.</span>
            </div>
            <div class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="medicalReactions" type="number">
              </mat-form-field>
              <span class="w-[80%]">Number of clients who experienced adverse medical reactions.</span>
            </div>
            <div class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="severeMedicalReactions" type="number">
              </mat-form-field>
              <span class="w-[80%]">Number of clients who experienced severe adverse medical reactions.</span>
            </div>
          </form>
        </div>

        <div *ngIf="currentQuestion == 3">
          <span><b>4. Averages (computed by service center)</b></span>
          <form [formGroup]="averagesForm">
            <div class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="averageClientUses" type="number">
              </mat-form-field>
              <span class="w-[80%]" *ngIf="data.showAveragesFields">Average number of times per client that psilocybin services were received</span>
              <span class="w-[80%]" *ngIf="!data.showAveragesFields">Average number of times per client that psilocybin services were received (numerical field, one decimal place)</span>
            </div>
            <div class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="averageClientsGroupAdministration" type="number">
              </mat-form-field>
              <span class="w-[80%]" *ngIf="data.showAveragesFields">Average number of clients participating in each group administration session</span>
              <span class="w-[80%]" *ngIf="!data.showAveragesFields">Average number of clients participating in each group administration session (numerical field, one decimal place)</span>
            </div>
            <div class="flex flex-row justify-start items-center gap-[10px]" *ngIf="!data.showAveragesFields">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="averageDose" type="number">
              </mat-form-field>
              <span class="w-[80%]">Average dose of psilocybin analyte consumed per client during an administration session (whole number, measured in milligrams)</span>
            </div>
            <div class="flex flex-row justify-start items-center gap-[10px]" *ngIf="data.showAveragesFields">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="averageDoseOverFiveMG" type="number">
              </mat-form-field>
              <span class="w-[80%]">For doses higher than 5mg of psilocybin analyte: average dose of psilocybin analyte consumed per client during an administration session (measured in milligrams)</span>
            </div>
            <div class="flex flex-row justify-start items-center gap-[10px]" *ngIf="data.showAveragesFields">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="averageDoseUnderFiveMG" type="number">
              </mat-form-field>
              <span class="w-[80%]">For doses of 5mg or less of psilocybin analyte: average dose of psilocybin analyte consumed per client during an administration session (measured in milligrams)</span>
            </div>
          </form>
        </div>

        <div *ngIf="currentQuestion == 4">
          <span><b>5. Number of post-session reactions</b></span>
          <form [formGroup]="postSessionReactionsForm">
            <div class="flex flex-row justify-start items-center gap-[10px]">
              <mat-form-field class="w-[10%]">
                <input matInput formControlName="postSessionReactions" type="number">
              </mat-form-field>
              <span class="w-[80%]">Number of clients who experienced post-session reactions</span>
            </div>
          </form>
        </div>

        <div *ngIf="currentQuestion == 5"  class="flex flex-col gap-3" style="padding-bottom: 20px">
          <div class="flex flex-col gap-3">
            <span><b>6. Partial Quarter Reporting</b></span>
            <span>Licensees are responsible for reporting both Client and Service Center data for all dates they were licensed within a quarter. The purpose of partial quarter reporting
              is so that service centers who will be closed for a substantive period of time or will otherwise not be licensed during an entire quarter can report the data for the actual days they are licensed during that quarter. </span>
            <span>Please enter the last date a client in your service center completed the <a href="https://www.oregon.gov/oha/PH/PREVENTIONWELLNESS/Documents/303-Client-Data-Form.pdf" target="_blank" rel="noreferrer noopener" style="word-break: break-all;
              white-space: normal;">303 Client Data Form</a> for this reporting window.</span>
            <div class="flex flex-row gap-4">
              <div class="flex flex-col gap-[10px]">
                <span><strong>Reporting Window Dates</strong></span>
                <span>Apr 1-25</span>
                <span>Jul 1-25</span>
                <span>Oct 1-25</span>
                <span>Jan 1-25</span>
              </div>
              <div class="flex flex-col gap-[10px]">
                <span><strong>Data to Enter</strong></span>
                <span>Q1 - Jan 1 - Mar 31</span>
                <span>Q2 - Apr 1 - Jun 30</span>
                <span>Q3 - Jul 1 - Sept 30</span>
                <span>Q4 - Oct 1 - Dec 31</span>
              </div>
            </div>
          </div>
          <form [formGroup]="partialQuarterForm" class="flex flex-row w-full">
            <mat-form-field class="flex flex-row w-1/2">
              <mat-label>Last date a client completed the 303 Client Data Form</mat-label>
              <input placeholder="mm/dd/yyyy"
                     formControlName="lastClientDate"
                     matInput
                     [matDatepicker]="lastClientDate"
                     [min]="minLastClientDate"
                     [max]="maxLastClientDate" />
              <mat-datepicker-toggle matSuffix [for]="lastClientDate"></mat-datepicker-toggle>
              <mat-datepicker #lastClientDate></mat-datepicker>
            </mat-form-field>
          </form>
        </div>
      </mat-card>
    </div>
  </div>
</div>

<div *ngIf="loading">
  <div id="globalLoader" [ngClass]="{'global-loader': true, 'global-loader-dark': sharedService.darkMode}">
    <h1>Loading</h1>
  </div>
</div>
